import NotFoundListingSearchBanner from '@components/views/components/NotFoundListingSearchBanner';
import { ListingNotFoundContentsViewModel } from '@api/v3';

import {
  Container,
  NotFoundListingSearchBannerWrapper,
  PopularAbroadToursList,
  PopularDomesticToursList,
} from './styled';
import TourListingNotFoundSearchBar from './TourListingNotFoundSearchBar';
import Card from '../Card';
import CardItem from '../CardItem';

type Props = {
  tourListCount: number;
  popularSearchData?: ListingNotFoundContentsViewModel;
};

const NotFoundTourListing = ({ tourListCount, popularSearchData }: Props) => {
  return (
    <Container>
      <TourListingNotFoundSearchBar
        tourListCount={tourListCount || 0}
        type='tour'
      />
      <NotFoundListingSearchBannerWrapper>
        <NotFoundListingSearchBanner
          label='Aradığınız kriterlerde tur bulunamadı.'
          description='Popüler turlara göz atabilirsiniz.'
        />
      </NotFoundListingSearchBannerWrapper>

      {popularSearchData?.tours?.popularDomesticTours?.length ? (
        <Card label={popularSearchData?.tours?.topTitle ?? ''}>
          <PopularDomesticToursList>
            {popularSearchData?.tours?.popularDomesticTours?.map((item) => (
              <CardItem
                key={item?.url ?? ''}
                url={item?.url ?? ''}
                image={{
                  url:
                    item?.images?.[0]?.url ?? '/static/images/placeholder.png',
                  alt: item?.images?.[0]?.alt ?? 'setur',
                }}
                label={item?.title ?? ''}
                type='tour'
              />
            ))}
          </PopularDomesticToursList>
        </Card>
      ) : null}

      {popularSearchData?.tours?.popularAbroadTours?.length ? (
        <Card label={popularSearchData?.tours?.subTitle ?? ''}>
          <PopularAbroadToursList>
            {popularSearchData?.tours?.popularAbroadTours?.map((item) => (
              <CardItem
                key={item?.url ?? ''}
                url={item?.url ?? ''}
                image={{
                  url:
                    item?.images?.[0]?.url ?? '/static/images/placeholder.png',
                  alt: item?.images?.[0]?.alt ?? 'setur',
                }}
                label={item?.title ?? ''}
                type='tour'
              />
            ))}
          </PopularAbroadToursList>
        </Card>
      ) : null}
    </Container>
  );
};

export default NotFoundTourListing;
